module.exports = __webpack_public_path__ + "static/media/SIDE-NAV.db39f0e7.png";